(function($){
	$("#gform_confirmation_message_5").append('<div class="FormComplete-wrapper"><a href="' + window.location.origin +' " class="FormComplete-anchor"> <span class="FormComplete-anchor--text"> Return To Homepage </span> </a></div>');

	var resume = $(".ApplicationForm--resume input");
	var form = $(".ApplicationForm--resume");
	var p = $("<p class='file-name'> </p>");

	form.append(p);


	 $(document).ready(function(){
       	resume.change(function(e){
            var fileName = e.target.files[0].name;
            p.html(String(fileName));
        });
	});
}(jQuery));





